<template>
    <section class="login_section">
    <div class="login-wrap">
        <div class="login-div">
            <div class="login-header"><img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-167"></div>
            <div class="login-form-div">
                <h1 class="heading-45">Welcome back</h1>
                <div class="text-block-201">Become your newself.</div>
                <div class="text-block-203">Enter the email address associated with your account and we will send you a link to reset your password.
                </div>
                <div class="div-block-1041">
                    <div class="w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-5" @submit.prevent="onSubmit">
                            <input class="login-user w-input" style="border-radius: 5px;" maxlength="256" name="email" v-model="email" data-name="Email" placeholder="Enter your email" type="email" id="email" @blur="validateEmail">
                    <div class="w-form-fail" style="display:block; margin-bottom: 10px;" v-if="emailError">
                        <div>Please enter a valid email address.</div>
                    </div>
                    <button class="submit-button-6 w-button" :disabled="submitted" style="margin-top:12px">
                        <div v-if="submitted">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                </circle>
                            </svg>
                        </div>
                        <div v-else>
                            <div class="">Request Reset Email</div>
                        </div>
                    </button>

                            <div class="text-block-1586">Forgot your login details?</div>
                            <div class="text-block-1587">
                                <a href="/forgot-password" class="link-80">Reset your password</a>
                            </div>
                        </form>
                        <div class="w-form-done" v-if="success">
                    <svg class="form-warning-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                    </svg>
                    <div>We have emailed you a link to reset your password.</div>
                </div>
                <div class="w-form-fail" style="display:block;" v-if="err">
                    <div>No user found with that email address.
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="height:280px"></div>
</section>
    

</template>

<script>
export default {
    name: 'ResetPassword',
    props: ['baseUrl'],
    data() {
        return {
            email: null,
            submitted: false,
            success: false,
            err: false,
            emailError: false,
        }
    },
    methods: {
        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        validateEmail() {
            if (this.email && this.email.trim()) {
                this.emailError = !this.isValidEmail(this.email.trim());
            } else {
                this.emailError = false;
            }
        },
        onSubmit() {
            this.validateEmail();
            if (this.emailError || !this.email || !this.email.trim()) {
                this.err = true;
                return;
            }
            this.submitted = true;
            this.err = false;
            this.$axios.post( `${this.baseUrl}/api/forgot-password`, {
                email: this.email.toLowerCase(),
            }).then(response => {
                if (response.data.status == 'success') {
                    this.success= true;
                    this.submitted = false;
                } else {
                    this.submitted = false;
                    this.err = true;
                }

            });

        },
    }
}
</script>

<style scoped>
/* Only ever rendered behind v-if="success" — safe to force display here. */
.w-form-done {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 16px;
    margin-top: 10px;
    background-color: #fef3c7;
    border: 1px solid #f59e0b;
    border-radius: 6px;
    color: #92400e;
    text-align: left;
}

.form-warning-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-top: 2px;
    color: #f59e0b;
}
</style>